<template>
  <div class="page-footer">
    <div class="web">
      <div class="text">
        京ICP11000850号-1
      </div>
      <div class="text">
        <div style="display: flex; align-items: center; justify-content: center;">
          <img style="width: 15px; margin-right: 5px;" src="@/assets/images/guohui.png" alt="">京公网专备11010502039775号
        </div>
      </div>
      <div class="text">信息网络传播视听节目许可证0111611</div>
      <div class="text">国家科技基础条件平台</div>
      <div class="text">&copy;2011-{{ new Date().getFullYear() }}版权所有：中国数字科技馆 未经书面许可任何人不得复制或镜像</div>
    </div>
    <div class="mobile">
      <div class="text">
        京ICP11000850号-1
      </div>
      <div class="text">
        <div style="display: flex; align-items: center; justify-content: center;">
          <img style="width: 15px; margin-right: 5px;" src="@/assets/images/guohui.png" alt="">京公网专备11010502039775号
        </div>
      </div>
      <div class="text">信息网络传播视听节目许可证0111611</div>
      <div class="text">国家科技基础条件平台</div>
      <div class="text">&copy;2011-{{ new Date().getFullYear() }}版权所有：中国数字科技馆 未经书面许可任何人不得复制或镜像</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.page-footer {
  // padding: 40px;
  height: 200px;
  width: calc(100vw);
  background: url(~@/assets/images/footer-background.png);
  background-position: center;background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  .guohui-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    .image {
      height: 40px;
      margin-bottom: 20px;
    }
  }
  .web {
    display: flex;
    flex-direction: column;

  }
  .mobile {
    display: none;
  }
  .text {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 30px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    vertical-align: top;
  }
}

@media screen and (max-width: 767px) {
  .page-footer {
    height: 200px;
    width: calc(100vw);
    padding: 20px;
    background: url(~@/assets/images/footer-background.png);
    background-position: center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    .guohui-container {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      .image {
        height: 40px;
        margin-bottom: 0px;
      }
    }
    .web {
      display: none;
    }
    .mobile {
      display: flex;
      flex-direction: column;
    }
    .text {
      font-size: 12px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 22px;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      vertical-align: top;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/Footer.vue